import { Col, Divider, Row } from 'antd';
import React, { useCallback } from 'react';
import { useParams } from 'react-router';

import { useGetVariantHistoryQuery } from '../../api/variantApi';

const VariantHistory = () => {
  const params = useParams();
  // Read history straight from the query hook's cache rather than a selector
  const { data: variantHistory } = useGetVariantHistoryQuery(
    { variant_id: params.vid },
    { skip: !params.vid },
  );

  const variantHistoryValueRenderer = useCallback(
    (label: string, value?: string | number, hasDivider?: boolean) => {
      return (
        <>
          <Col>
            <div className="variant-summary__field-label">{label}</div>
            <div className="variant-summary__field-value">{value}</div>
          </Col>
          {hasDivider && (
            <Divider type="vertical" style={{ height: '2.9em' }} />
          )}
        </>
      );
    },
    [],
  );

  return (
    <Row
      className="variant-summary__history"
      align={'middle'}
      justify={'space-between'}
      style={{ marginBottom: '1.5rem' }}
    >
      {variantHistoryValueRenderer('Created on', variantHistory?.created, true)}
      {variantHistoryValueRenderer(
        'Created by',
        variantHistory?.created_by,
        true,
      )}
      {variantHistoryValueRenderer(
        'Institution',
        variantHistory?.institution,
        true,
      )}
      {variantHistoryValueRenderer(
        'Last interpreted on',
        variantHistory?.interpreted,
        true,
      )}
      {variantHistoryValueRenderer(
        'Last interpreted by',
        variantHistory?.interpreted_by,
      )}
      {variantHistoryValueRenderer('Confirmed', variantHistory?.confirmations)}
    </Row>
  );
};

export default VariantHistory;
